import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import o from "../Color.js";
import { JSONMap as r } from "../core/jsonMap.js";
import { clone as t } from "../core/lang.js";
import { toPt as s } from "../core/screenUtils.js";
import { property as i } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as l } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import { writer as a } from "../core/accessorSupport/decorators/writer.js";
import n from "./MarkerSymbol.js";
import c from "./SimpleLineSymbol.js";

var _h;

var m = new r({
  esriSMSCircle: "circle",
  esriSMSSquare: "square",
  esriSMSCross: "cross",
  esriSMSX: "x",
  esriSMSDiamond: "diamond",
  esriSMSTriangle: "triangle",
  esriSMSPath: "path"
});

var u = _h = /*#__PURE__*/function (_n) {
  _inherits(h, _n);

  var _super = _createSuper(h);

  function h() {
    var _this;

    _classCallCheck(this, h);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.color = new o([255, 255, 255, .25]), _this.type = "simple-marker", _this.size = 12, _this.style = "circle", _this.outline = new c();
    return _this;
  }

  _createClass(h, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, o, r, t) {
      if (e && "string" != typeof e) return e;
      var i = {};
      return e && (i.style = e), null != o && (i.size = s(o)), r && (i.outline = r), t && (i.color = t), i;
    }
  }, {
    key: "writeColor",
    value: function writeColor(e, o) {
      e && "x" !== this.style && "cross" !== this.style && (o.color = e.toJSON()), null === e && (o.color = null);
    }
  }, {
    key: "path",
    set: function set(e) {
      this.style = "path", this._set("path", e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _h({
        angle: this.angle,
        color: t(this.color),
        outline: this.outline && this.outline.clone(),
        path: this.path,
        size: this.size,
        style: this.style,
        xoffset: this.xoffset,
        yoffset: this.yoffset
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      var e;
      return "".concat(_get(_getPrototypeOf(h.prototype), "hash", this).call(this), ".").concat(this.color && this.color.hash(), ".").concat(this.path, ".").concat(this.style, ".").concat(null == (e = this.outline) ? void 0 : e.hash());
    }
  }]);

  return h;
}(n);

e([i()], u.prototype, "color", void 0), e([a("color")], u.prototype, "writeColor", null), e([l({
  esriSMS: "simple-marker"
}, {
  readOnly: !0
})], u.prototype, "type", void 0), e([i()], u.prototype, "size", void 0), e([i({
  type: m.apiValues,
  json: {
    read: m.read,
    write: m.write
  }
})], u.prototype, "style", void 0), e([i({
  type: String,
  json: {
    write: !0
  }
})], u.prototype, "path", null), e([i({
  types: {
    key: "type",
    base: null,
    defaultKeyValue: "simple-line",
    typeMap: {
      "simple-line": c
    }
  },
  json: {
    default: null,
    write: !0
  }
})], u.prototype, "outline", void 0), u = _h = e([p("esri.symbols.SimpleMarkerSymbol")], u);
var y = u;
export { y as default };